<template>
  <div id="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile/>
      <b-link class="navbar-brand" to="#">
        <img
          class="navbar-brand-full"
          src="./assets/img/crx-logo.png"
          width="215"
          height="80"
          alt="ConnectiveRx"
        >
        <img
          class="navbar-brand-minimized"
          src="./assets/img/crx-monogram.png"
          width="30"
          height="30"
          alt="ConnectiveRx"
        >
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg"></SidebarToggler>
      <b-navbar-nav class="d-md-down-none">
        <b-nav-text class="page-title">{{this.$route.meta.title}}</b-nav-text>
        <!-- <b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>
        <b-nav-item class="px-3">Settings</b-nav-item>-->
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <!-- <b-nav-item class="d-md-down-none">
          <i class="icon-bell"></i>
          <b-badge pill variant="danger">5</b-badge>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <i class="icon-list"></i>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <i class="icon-location-pin"></i>
        </b-nav-item>-->
        <b-nav-item class="d-md-down-none">
          <profile></profile>
        </b-nav-item>
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
      <!--<AsideToggler class="d-lg-none" mobile /> -->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <!-- <b-breadcrumb :items="breadCrumbs"/> -->
        <b-alert
          class="top-alert"
          variant="danger"
          :show="errorMessage!==null && errorMessage !==''"
          dismissible
          @dismissed="errorMessageDismissed"
        ><span v-html="errorMessage"></span></b-alert>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <!-- <AppAside fixed>
        <DefaultAside/>
      </AppAside>-->
    </div>
    <AppFooter>
      <div>
        <a href="https://connectiverx.com">ConnectiveRx</a>
        <span>© 2018</span>
      </div>
    </AppFooter>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import { ERROR_CLEAR_ERROR } from "./store/error/actions.type.js";
  import Profile from "@/components/profile";
  /* Import Bootstrap Vue Styles */
  import "@coreui/icons/css/coreui-icons.min.css";
  import "bootstrap-vue/dist/bootstrap-vue.css";
  /* Import Flag Icons Set */
  import "flag-icon-css/css/flag-icon.min.css";
  import "vue-multiselect/dist/vue-multiselect.min.css";
  import "vue-query-builder/dist/VueQueryBuilder.css";
  import {
    Header as AppHeader,
    SidebarToggler,
    Sidebar as AppSidebar,
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNav,
    Aside as AppAside,
    AsideToggler,
    Footer as AppFooter
  } from "@coreui/vue";

  export default {
    name: "app",
    components: {
      Profile,
      AsideToggler,
      AppHeader,
      AppSidebar,
      AppAside,
      AppFooter,
      SidebarForm,
      SidebarFooter,
      SidebarToggler,
      SidebarHeader,
      SidebarNav,
      SidebarMinimizer
    },
    computed: {
      ...mapState({
        nav: state => state.nav.menuItems,
        errorMessage: state => state.error.message
      }),
      breadCrumbs() {
        if (this.$route.meta.breadCrumbs) {
          return this.$route.meta.breadCrumbs;
        } else if (this.$route.meta.title) {
          return [{ text: this.$route.meta.title, active: true }];
        }
        return [{ text: this.$route.name, active: true }];
      }
    },
    methods: {
      errorMessageDismissed() {
        this.$store.dispatch(ERROR_CLEAR_ERROR);
      }
    }
  };
</script>

<style lang="scss">
  @import "assets/scss/style";
</style>



// WEBPACK FOOTER //
// src/App.vue